/**
 * Utilities for working with CSS variables
 */

const cssVarNameRegex = /var\((?<name>[a-z0-9-]+)\)/;

/**
 * Extracts the CSS variable name from a var() expression
 */
export const getCssVarName = (varExpression: string): string | undefined => {
  return cssVarNameRegex.exec(varExpression)?.groups?.name;
};

/**
 * Gets the computed value of a CSS variable
 */
export const getCssVarValue = (varExpression: string): string | undefined => {
  const varName = getCssVarName(varExpression);

  if (!varName) {
    return;
  }

  // getPropertyValue returns empty string for unset properties.
  return getComputedStyle(document.body).getPropertyValue(varName) || undefined;
};
